module.exports = __webpack_public_path__ + "static/media/LearnCreatorProgramResources.c83af8ce.png";